var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNetball(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "at9wyu6xta",
    d: "M0.14 0.118L9.9 0.118 9.9 10.301 0.14 10.301z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "40yqbrm8gc",
    d: "M0 0L11.927 0 11.927 13.226 0 13.226z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fkuupimcpe",
    d: "M0.666 -0.003L17.752 -0.003 17.752 9.9 0.666 9.9z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#B0F0FF",
    d: "M10.71 10.081c-.026-.517-.064-1.847.118-3.502 3.62.905 6.709 3.362 9.18 7.314l.033.054c-.408 1.1-1 2.115-1.737 3.002-.762-1.539-2.954-5.088-7.594-6.868m9.763-1.824c-1.159-1.798-3.85-5.054-8.61-6.163.237-.62.518-1.233.856-1.815 3.892.92 6.943 4.043 7.754 7.978"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.8 2.7)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "gaad2v832b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#at9wyu6xta"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#003DB3",
    d: "M.14 3.112C.278 2.162.493 1.136.82.118 7.077 1.532 9.764 6.976 9.9 7.627l.001.023c0 .916-.121 1.804-.345 2.65C7.008 6.429 3.843 4.013.14 3.113",
    mask: "url(#gaad2v832b)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "0dmczv4fqd",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#40yqbrm8gc"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#B0F0FF",
    d: "M11.927.121c-2.229 4.036-2.043 9.07-1.979 10.087-.686.695-1.587 1.23-2.563 1.643C6.47 8.216 7.184 4.321 9.52.268l.138-.243C9.884.01 10.112 0 10.343 0c.539 0 1.067.041 1.584.121M3.75 2.383C2.589 4.671 1.292 8.537 2.458 13.063c-.911.11-1.65.149-2.049.162C.145 12.312 0 11.348 0 10.35 0 7.149 1.46 4.282 3.75 2.382",
    mask: "url(#0dmczv4fqd)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003DB3",
    d: "M5.209 1.37C6.276.758 7.46.329 8.722.129c-2.348 4.18-3.04 8.215-2.058 12.002-1.158.41-2.374.668-3.442.83-1.436-5.427.883-9.878 1.987-11.59"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 10.8)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "9k4buiaxhf",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fkuupimcpe"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#003DB3",
    d: "M2.358 6.114c-.715-.87-1.289-1.857-1.692-2.929 1.766-.073 7.078-.516 9.778-3.188 1.008.388 1.898.868 2.675 1.395C10.636 4.17 7.034 5.76 2.4 6.112l-.041.002M10.349 9.9c-1.174 0-2.304-.2-3.357-.563 2.38-.113 6.233-.95 9.513-4.654.644.885 1.044 1.65 1.247 2.084C15.872 8.697 13.25 9.9 10.35 9.9",
    mask: "url(#9k4buiaxhf)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#B0F0FF",
    d: "M2.947 17.624c4.612-.452 8.223-2.126 10.744-4.98.937.717 1.692 1.492 2.288 2.224-4.235 4.876-9.661 4.584-10.825 4.456-.811-.466-1.553-1.04-2.207-1.7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNetball);
export default __webpack_public_path__ + "static/media/netball.af09d58f3575f5198e0edf6354ca9783.svg";
export { ForwardRef as ReactComponent };